import { nextTick } from 'vue';
import { GlTooltipDirective, GlButton } from '@gitlab/ui';
import isEmpty from 'lodash/isEmpty';
import { checkClipboardPermissions } from '../utils';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

function makePretty(value) {
  let visited = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new WeakSet();
  if (isEmpty(value)) return {
    result: '',
    isJson: false
  };
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return {
        result: JSON.stringify(parsed, null, 2),
        isJson: true
      };
    } catch (e) {
      return {
        result: value,
        isJson: false
      };
    }
  }
  try {
    if (typeof value === 'object' && visited.has(value)) {
      return {
        result: '',
        isJson: false
      };
    }
    if ('content' in value) {
      visited.add(value);
      return makePretty(value.content, visited);
    }
    return {
      result: JSON.stringify(value, null, 2),
      isJson: true
    };
  } catch (e) {
    return {
      result: String(value),
      isJson: false
    };
  }
}
var script = {
  name: 'ToolKvSection',
  directives: {
    GlTooltip: GlTooltipDirective
  },
  components: {
    GlButton
  },
  inject: {
    renderGFM: {
      from: 'renderGFM',
      default: () => element => {
        element.classList.add('gl-markdown', 'gl-compact-markdown');
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array, Object, null],
      required: false,
      default: null
    },
    // Optional monospace + scroll (useful for JSON / logs)
    maxHeight: {
      type: String,
      required: false,
      default: '260px'
    }
  },
  computed: {
    prettyResult() {
      return makePretty(this.value);
    },
    pretty() {
      return this.prettyResult.result;
    },
    hasContent() {
      return this.pretty && this.pretty.length > 0;
    },
    isJson() {
      return this.prettyResult.isJson;
    }
  },
  async mounted() {
    if (this.isJson) {
      await nextTick();
      this.applyJsonHighlight();
    }
  },
  methods: {
    async copy() {
      const textToCopy = this.pretty;
      const hasClipboardPermission = await checkClipboardPermissions();
      try {
        // Dispatch custom event for VS Code and other environments
        // This bubbles up to parent components that handle clipboard operations
        this.$el.dispatchEvent(new CustomEvent('copy-code-snippet', {
          bubbles: true,
          cancelable: true,
          detail: {
            code: textToCopy
          }
        }));

        // If we have clipboard permission, also copy directly
        if (hasClipboardPermission) {
          await navigator.clipboard.writeText(textToCopy);
        }
        this.$emit('copied', this.title);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Failed to copy:', e);
      }
    },
    async applyJsonHighlight() {
      if (this.renderGFM && typeof this.renderGFM === 'function' && this.$refs.content) {
        this.renderGFM(this.$refs.content);
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('section',[_c('header',{staticClass:"gl-display-flex gl-align-items-center gl-justify-content-space-between gl-mb-2",attrs:{"data-testid":"tool-section-header"}},[_c('div',{staticClass:"gl-display-flex gl-align-items-center gl-gap-2"},[_c('strong',{staticClass:"gl-text-gray-900"},[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"gl-display-block gl-relative gl-block gl-rounded-base gl-border-gray-100 gl-bg-gray-50 gl-p-5",style:({ maxHeight: _vm.maxHeight, overflow: 'auto' })},[_c('div',{staticClass:"gl-absolute gl-right-5 gl-top-5 gl-z-1"},[(_vm.pretty)?_c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"category":"tertiary","size":"small","icon":"copy-to-clipboard","title":"Copy to clipboard","aria-label":"Copy to clipboard"},on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)}}}):_vm._e()],1),_vm._v(" "),_c('pre',{ref:"content",staticClass:"gl-font-mono gl-m-0 !gl-border-0 gl-text-gray-900",class:_vm.isJson ? 'code js-syntax-highlight language-json' : '',staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.pretty))])])]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
